import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import XHR from 'i18next-xhr-backend';
import { getLanguageFromTenant } from './index';
import { ExternalSearchParamsContextProps } from '@ibe/components';

const order = ['querystring', 'localStorage', 'navigator'];

const initI18next = async (
  baseUrl?: string,
  version?: string,
  tenant?: string,
  mode?: ExternalSearchParamsContextProps['mode']
): Promise<void> => {
  let translationsUrl;
  if (mode === 'LOCAL') {
    translationsUrl = `/translations/generated/{{ns}}.{{lng}}.json`;
  } else {
    translationsUrl = `${baseUrl}/.rest/translations/{{ns}}.{{lng}}.json`;
  }

  const language = getLanguageFromTenant(tenant);

  await i18next
    .use(initReactI18next)
    .use(Backend)
    .init({
      lng: language,
      fallbackLng: ['de'],
      fallbackNS: false,
      ns: [],
      debug: false,
      cleanCode: true,
      saveMissing: false,
      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      },
      react: {
        useSuspense: true
      },
      backend: {
        backends: [XHR],
        allowMultiLoading: true,
        backendOptions: [
          {
            loadPath: translationsUrl,
            queryStringParams: { v: `${version ? version : '1.0.0'}` }
          }
        ]
      },
      detection: {
        order
      }
    });
};

export default initI18next;
